import React from "react";

export default function Footer(){
    return(  <footer>
        <a href="https://github.com/acapasso90/react-weatherapp" target="_blank" rel="noreferrer" className="githubLink"> Open-source code </a> 
        by  <a href="https://www.amandacapasso.com" target="_blank" rel="noreferrer" className="businessLink"> Amanda Capasso </a>
      </footer>)
}